module.exports = __webpack_public_path__ + "images/destinations/chatwork.png";